<template>
    <div class="cielo-checkbox">
        <div class=" cielo-checkbox__container">
            <input class="cielo-checkbox__input" type="checkbox" :checked="value" @input="$emit('input', !value)" :aria-label="textAria" />

            <div class="cielo-checkbox__label-container">
                <i class="cielo-checkbox__icon" />

                <label class="cielo-checkbox__label">{{ label }}</label>
            </div>
        </div>

        <div 
            v-if="!!$slots.default"
            class="cielo-checkbox__slot"
            @click="handleSlotClick(value)" 
        >
            <slot />
        </div>
    </div>
</template>

<script>
  export default {
      props: {
          value: {
              type: Boolean,
              default: false
          },
          label:{
              type: String,
              default:''
          },
          clickableSlot:{
              type: Boolean,
              default: false
          },
          textAria:{
            type: String,
            default: ''
          }
      },
      
      methods: {
        handleSlotClick(value) {
          if(this.clickableSlot) this.$emit('input', !value);
        }
      }
  };
</script>

<style lang="scss">
  .cielo-checkbox {
      display: flex;

      &__input,
      &__slot {
          cursor: pointer;
      }

      &__slot span,
      &__slot a,
      &__label {
          font-size: 14px;
          line-height: 24px;
          margin: 0;
      }
        
      &__slot {
        span {
            color: #2F363E;
            font-weight: 500;
        }
          
        a {
            color: #0774E7;
            font-weight: 600;
            text-decoration: underline;
            display: inline-block;
        }
        
      }
        
      &__label {
          color: #2F363E;
          font-weight: 500;
      }

      &__container {
          display: flex;
          position: relative;
      }

      &__input {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          cursor: pointer;
          opacity: 0;
          z-index: 3;

          &:checked ~ .cielo-checkbox__label-container .cielo-checkbox__icon::after {
              opacity: 1;
          }

          &:checked ~ .cielo-checkbox__label-container .cielo-checkbox__icon {
              border-color: #0774E7;
        }

      }

      &__label-container {
          display: flex;
          align-items: center;
      }

      &__icon {
          display: block;
          width: 24px;
          height: 24px;
          border: 1px solid #C5CED7;
          border-radius: 4px;
          margin-right: 16px;
          position: relative;
          transition: all .3s ease;
          flex: 1 0 auto;

          &:after {
              content: url('../../../assets/img/checkbox-checked.svg');
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              opacity: 0;
              transition: all .3s ease;
          }
      }

  }
  
</style>